import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  items: [],
  count: 0,
  full: {}
}

const getListActions = generateActions('news/list/GET')
const getCountActions = generateActions('news/list/GET_COUNT')
const getSingleActions = generateActions('news/list/GET_SINGLE')

export const get = createAction(
  API_CONST,
  (params = {}) => ({
    params,
    url: 'articles',
    actions: getListActions
  }),
  (params = {}) => ({ rewrite: !params.offset })
)

export const getCount = createAction(
  API_CONST,
  () => ({
    url: 'articles/count',
    actions: getCountActions
  })
)

export const getSingle = createAction(
  API_CONST,
  id => ({
    url: `articles/${id}`,
    actions: getSingleActions
  }),
  id => ({ id })
)

export default handleActions({
  [getListActions[0]]: (state, { meta = {} }) => ({ ...state, items: meta.rewrite ? [] : [ ...state.items ] }),
  [getListActions[1]]: (state, { payload }) => ({ ...state, items: [ ...state.items, ...payload ] }),
  [getCountActions[0]]: state => ({ ...state, count: 0 }),
  [getCountActions[1]]: (state, { payload }) => ({ ...state, count: payload.value }),
  [getSingleActions[0]]: (state, { meta }) => ({
    ...state,
    full: {
      ...state.full,
      [meta.id]: null
    }
  }),
  [getSingleActions[1]]: (state, { payload, meta }) => ({
    ...state,
    full: {
      ...state.full,
      [meta.id]: payload
    }
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/news/index.js